import { render, staticRenderFns } from "./LocationModel.vue?vue&type=template&id=bf75f428"
import script from "./LocationModel.vue?vue&type=script&lang=js"
export * from "./LocationModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports